@let address = workingAddress();
<form class="addressForm" #addressDetailForm="ngForm">
  @if (errorMessage()) {
    <div class="errorMessage">{{ errorMessage() }}</div>
  }
  <table class="addressDetailTable">
    @if (isEdit()) {
      <tr>
        <td colspan="2" class="centeredCell inputColumn">
          <button matButton="text" [disabled]="!address.addressId || address.defaultShipTo"
            (click)="setDefaultShippingAddress()">
            <span>
              <mat-icon class="size-16">location_on</mat-icon>
              <label>Default Ship To</label>
            </span>
          </button>
          <button matButton="text" [disabled]="!address.addressId || address.defaultBillTo"
            (click)="setDefaultBillingAddress()">
            <span>
              <mat-icon class="size-16">attach_money</mat-icon>
              <label>Default Bill To</label>
            </span>
          </button>
          <button class="primary-button" matButton="text" [disabled]="addressDetailForm.invalid" (click)="save()">
            <span>
              <mat-icon class="size-16">done</mat-icon>
              <label>Save</label>
            </span>
          </button>
          @if (!address.addressId) {
            <button class="warn-button" matButton="text" (click)="cancel()">
              <span>
                <mat-icon class="size-16">clear</mat-icon>
                <label>Cancel</label>
              </span>
            </button>
          }
        </td>
      </tr>
    }
    @if (!isDealerAddress()) {
      <tr>
        <td class="labelColumn">
          <label for="addressTypeSelection">Address Type:</label>
        </td>
        <td class="inputColumn">
          <select name="addressTypeSelection" id="addressTypeSelection" class="inputField" [(ngModel)]="address.typeCode">
            @for (addressType of addressTypes(); track addressType) {
              <option [value]="addressType.code">{{ addressType.description }}
              </option>
            }
          </select>
        </td>
      </tr>
    }
    <tr>
      <td class="labelColumn">
        <label for="attentionLineInput">*{{isDealerAddress() ? 'Dealer Name' : 'Ship To Name'}}:</label>
      </td>
      <td class="inputColumn">
        <input id="attentionLineInput" name="attentionLineInput" maxlength="25" class="inputField standardTextBox"
               [ngClass]="{'inputError': attentionLine.invalid}" required
               [(ngModel)]="address.attentionLine"
               #attentionLine="ngModel" />
      </td>
    </tr>
    <tr>
      <td class="labelColumn">
        <label for="addressLine1Input">*Address Line 1:</label>
      </td>
      <td class="inputColumn">
        <input id="addressLine1Input" name="addressLine1Input" maxlength="25" class="inputField standardTextBox"
          [ngClass]="{'inputError': addressLine1.invalid}" required [(ngModel)]="address.addressLine1"
          #addressLine1="ngModel"/>
      </td>
    </tr>
    <tr>
      <td class="labelColumn">
        <label for="addressLine2Input">Address Line 2:</label>
      </td>
      <td class="inputColumn">
        <input id="addressLine2Input" name="addressLine2Input" maxlength="25" class="inputField standardTextBox"
          [(ngModel)]="address.addressLine2"/>
      </td>
    </tr>
    <tr>
      <td class="labelColumn">
        <label for="cityInput">*City:</label>
      </td>
      <td class="inputColumn">
        <input id="cityInput" name="cityInput" class="inputField standardTextBox" maxlength="16"
          [ngClass]="{'inputError': cityName.invalid}" required [(ngModel)]="address.cityName"
          #cityName="ngModel"/>
      </td>
    </tr>
    <tr>
      <td class="labelColumn">
        <label for="stateSelection">*State:</label>
      </td>
      <td class="inputColumn">
        <select name="stateSelection" id="stateSelection" class="inputField" required
          [ngClass]="{'inputError': stateInput.invalid}" [(ngModel)]="address.stateCode" #stateInput="ngModel">
          <option value="undefined" disabled>Please Select</option>
          @for (state of stateCodes(); track state) {
            <option [value]="state.code">{{ state.description }}</option>
          }
        </select>
      </td>
    </tr>
    <tr>
      <td class="labelColumn">
        <label for="zipInput">*Postal Code:</label>
      </td>
      <td class="inputColumn">
        <input id="zipInput" name="zipInput" class="inputField standardTextBox" maxlength="20" required
          [ngClass]="{'inputError': zipInput.invalid}" [(ngModel)]="address.postalCode" #zipInput="ngModel"/>
      </td>
    </tr>
    <tr>
      <td class="labelColumn">
        <label for="countrySelection">*Country:</label>
      </td>
      <td class="inputColumn">
        <select name="countrySelection" id="countrySelection" class="inputField" required
          [ngClass]="{'inputError': countryInput.invalid}" [(ngModel)]="address.countryCode"
          #countryInput="ngModel">
          <option value="undefined" disabled>Please Select</option>
          @for (country of countryCodes(); track country) {
            <option [value]="country.code">
              {{ country.description }}
            </option>
          }
        </select>
      </td>
    </tr>
    @if (isEdit()) {
      <tr>
        <td colspan="2" class="inputColumn"><label>Created: {{ address.createUser }}
        - {{ address.createTimestamp | date: 'MM/dd/yyyy h:mm:ss a':'UTC' }}</label></td>
      </tr>
    }
    @if (isEdit()) {
      <tr>
        <td colspan="2" class="inputColumn"><label>Updated: {{ address.updateUser }}
        - {{ address.updateTimestamp | date: 'MM/dd/yyyy h:mm:ss a':'UTC' }}</label></td>
      </tr>
    }
  </table>
  @if (isBusy()) {
    <div class="busyIndicator">
      <div class="busyContents">
        <mat-progress-spinner diameter="48" mode="indeterminate"></mat-progress-spinner>
        <label class="busyLabel">Please Wait...</label>
      </div>
    </div>
  }
</form>
